import React from 'react';
import './Position.css';

import { Button } from '../../components';

import { FaMapMarkerAlt, FaMoneyBill } from 'react-icons/fa';

import { Link } from 'react-router-dom';



const Position = ({ position }) => {

  return (

    /* Container for each job position item */
    <div className='position-item' key={position.id}>

      <div className='content'>

        <span>{position.details.timing}</span>

        {/* Link to the individual job position page */}
        <Link
          to={{
            pathname: '/Careers/' + position.title,  // Navigate to specific job position page
          }}
          state={position}  // Pass position details to the linked page
          className='main-heading' >
          <h3>{position.title}</h3> {/* Display job title */}
        </Link>

        <div className='details'>
          <h5><FaMapMarkerAlt className='icon' /><span>{position.details.location}</span></h5> {/* Location of the job */}
          <h5><FaMoneyBill className='icon' /><span>{position.details.salary}</span></h5> {/* Salary for the job */}
        </div>

      </div>

      <Button link={'CareerForm'} title={'Apply Now'} /> {/* 'Apply Now' button which redirects to the career form */}

    </div>

  );
};

export default Position;